module.exports = "/_next/static/images/crisssross_top-b629ee45970a7c917bafac67aaf384d8.jpg";